package com.example.mystybag.logoutUtils.helpers

import kotlinx.coroutines.CoroutineDispatcher
import kotlinx.coroutines.Dispatchers

actual object LogoutDispatchers {
    actual val IO: CoroutineDispatcher = Dispatchers.Default
}
